'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _baseReportController = require('../../reports/baseReportController');

var _baseReportController2 = _interopRequireDefault(_baseReportController);

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DataUtilityController = function (_BaseReportController) {
  (0, _inherits3.default)(DataUtilityController, _BaseReportController);

  function DataUtilityController(authService, reportingService, appConfig, enums, loadingService, utilsService, adminService, webEnquiriesService, $ngConfirm, growl, entityService, exportService) {
    "ngInject";

    (0, _classCallCheck3.default)(this, DataUtilityController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (DataUtilityController.__proto__ || (0, _getPrototypeOf2.default)(DataUtilityController)).call(this, reportingService, loadingService, utilsService));

    _this.authService = authService;
    _this.reportingService = reportingService;
    _this.appConfig = appConfig;
    _this.enums = enums;
    _this.loadingService = loadingService;
    _this.utilsService = utilsService;
    _this.adminService = adminService;
    _this.webEnquiriesService = webEnquiriesService;
    _this.$ngConfirm = $ngConfirm;
    _this.growl = growl;
    _this.entityService = entityService;
    _this.exportService = exportService;

    _this.reportCriteria = {};
    _this.dtPopups = {};
    _this.errMsgs = [];

    _this.panels = {
      reportCriteria: true,
      reportData: true
    };

    _this.getLocations().then(function (response) {
      _this.getDateRangeList();
      _this.getEnquiryStatusList();
      _this.reset();
    });

    return _this;
  }

  (0, _createClass3.default)(DataUtilityController, [{
    key: 'convertEnumToKeyValueList',
    value: function convertEnumToKeyValueList(enumObj, defaultOption) {
      var objList = [];

      if (defaultOption) {
        objList.push({
          id: null,
          name: 'Please Select'
        });
      }

      for (var prop in enumObj) {
        objList.push({
          id: enumObj[prop],
          name: prop
        });
      }

      return objList;
    }
  }, {
    key: 'getDateRangeList',
    value: function getDateRangeList() {
      this.dateRangeList = this.convertEnumToKeyValueList(this.enums.DATE_RANGE_TYPE);
    }
  }, {
    key: 'getLocations',
    value: function getLocations() {
      var _this2 = this;

      var source = this.entityService.listAllLocations();

      source.then(function (response) {
        var firstItem = {
          entityId: null,
          name: '---- Select Location ----'
        };

        _this2.locations = [firstItem].concat((0, _toConsumableArray3.default)(response.data.items));
      });

      return source;
    }
  }, {
    key: 'showDatePopup',
    value: function showDatePopup(fieldName) {
      this.dtPopups[fieldName] = true;
    }
  }, {
    key: 'getEnquiryStatusList',
    value: function getEnquiryStatusList() {
      this.enquiryStatusList = [{ id: null, name: 'All' }, { id: 1, name: 'Open' }, { id: 3, name: 'Confirmed' }];
    }
  }, {
    key: 'reset',
    value: function reset() {
      this.errMsgs = [];
      this.toggleState = null;
      this.openEnquiries = null;

      this.reportCriteria.dateRangeOption = this.dateRangeList[0];
      this.reportCriteria.startDate = new Date();
      this.reportCriteria.endDate = new Date();
      this.reportCriteria.location = this.locations[0];
      this.reportCriteria.additionalParameter1 = null;
      this.reportCriteria.enquiryStatus = this.enquiryStatusList[0];
    }
  }, {
    key: 'validateCriteria',
    value: function validateCriteria() {
      this.errMsgs = [];

      if (!this.reportCriteria.startDate) {
        this.errMsgs.push('Please provide a Start Date');
      }

      if (!this.reportCriteria.endDate) {
        this.errMsgs.push('Please provide an End Date');
      }

      if (this.reportCriteria.endDate && this.reportCriteria.startDate > this.reportCriteria.endDate) {
        this.errMsgs.push('Start Date can not be greater than End Date');
      }

      if (this.reportCriteria.location.entityId == null) {
        this.errMsgs.push('Please select a location');
      }

      return this.errMsgs.length === 0;
    }
  }, {
    key: 'parseCriteria',
    value: function parseCriteria() {
      var parsedCriteria = {};

      this.parseStartAndEndDate(parsedCriteria);

      parsedCriteria.locationIds = [this.reportCriteria.location.entityId];
      parsedCriteria.additionalParameter1 = this.reportCriteria.additionalParameter1;
      parsedCriteria.enquiryStatus = this.reportCriteria.enquiryStatus.id;

      return parsedCriteria;
    }
  }, {
    key: 'viewOpenEnquiries',
    value: function viewOpenEnquiries() {
      var _this3 = this;

      if (!this.validateCriteria()) {
        return;
      }

      this.loadingService.showLoading('webEnquiriesList', 'Loading Open Enquiries ...');

      this.adminService.listOpenEnquiries(this.parseCriteria()).then(function (response) {
        _this3.toggleState = null;
        _this3.openEnquiries = response.data;
      }).catch(function (err) {}).finally(function () {
        _this3.loadingService.hideLoading('webEnquiriesList');
      });
    }
  }, {
    key: 'toggleCheck',
    value: function toggleCheck() {
      var _this4 = this;

      if (!this.openEnquiries || !this.openEnquiries.length) {
        this.toggleState = null;
        return;
      }

      if (this.toggleState === null) {
        this.toggleState = true;
      } else {
        this.toggleState = !this.toggleState;
      }

      this.openEnquiries.map(function (we) {
        we.checked = _this4.toggleState;
      });
    }
  }, {
    key: 'checkToggle',
    value: function checkToggle() {
      var allChecked = true;

      this.openEnquiries.map(function (we) {
        allChecked = allChecked && we.checked;
      });

      this.toggleState = allChecked;
    }
  }, {
    key: 'confirmCloseOpenEnquiries',
    value: function confirmCloseOpenEnquiries() {
      var _this5 = this;

      if (!this.openEnquiries || !this.openEnquiries.length) {
        return;
      }

      this.$ngConfirm({
        title: "Close Open Enquiries",
        content: 'Are you sure you want to close the selected open enquiries? \n        <br>This will mark Open Enquiries as <b>Lost</b> and Confirmed Enquiries as <b>Closed</b>. \n        <br>Any vehicles / trade ins attached will be updated accordinly. \n        <br><br>Changes cannot be undone',
        type: 'orange',
        columnClass: 'l',
        buttons: {
          renew: {
            text: 'Im sure, close open enuiries',
            btnClass: 'btn-primary',
            action: function action() {
              _this5.closeOpenEnquiries();
            }
          },
          cancel: {
            text: 'Leave it',
            btnClass: 'btn-default',
            action: function action() {}
          }
        }
      });
    }
  }, {
    key: 'closeOpenEnquiries',
    value: function closeOpenEnquiries() {
      var _this6 = this;

      var enquiryIds = this.openEnquiries.filter(function (oe) {
        return oe.checked;
      }).map(function (oe) {
        return oe.enquiryId;
      });

      this.loadingService.showLoading('webEnquiriesList', 'Closing Open Enquiries ...');

      this.adminService.closeOpenEnquiries(enquiryIds).then(function (response) {
        _this6.growl.success('Successfully updated ' + response.data.length + ' out of ' + enquiryIds.length + ' enquiries', { ttl: 5000 });
        var updatedEnuiries = (0, _lodash.filter)(_this6.openEnquiries, function (oe) {
          return response.data.includes(oe.enquiryId);
        });
        _lodash.pull.apply(undefined, [_this6.openEnquiries].concat((0, _toConsumableArray3.default)(updatedEnuiries)));
      }).catch(function (err) {
        _this6.growl.error('Could not update enquiries', { ttl: 5000 });
      }).finally(function () {
        _this6.loadingService.hideLoading('webEnquiriesList');
      });
    }
  }, {
    key: 'exportReport',
    value: function exportReport() {
      if (!this.validateCriteria()) {
        return;
      }

      this.exportService.exportReport('Data Utility', this.parseCriteria());
    }
  }]);
  return DataUtilityController;
}(_baseReportController2.default);

exports.default = DataUtilityController;


// WEBPACK FOOTER //
// ./client/app/components/admin/dataUtility/dataUtility.controller.js